import * as React from "react"
import type { IconProps } from "../types"

const Undo = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6.49985 5L3.20696 8.29289C2.81643 8.68342 2.81643 9.31658 3.20696 9.70711L6.49985 13M3.99985 9H16.9998C19.209 9 20.9998 10.7909 20.9998 13V14C20.9998 16.2091 19.209 18 16.9998 18H11.9998"
        />
      </svg>
    )
  }
)
Undo.displayName = "Undo"

export default Undo
